export class Page {
  public static readonly SIGN_UP = new Page('Sign up', 'Sign Up');

  public static readonly SIGN_IN = new Page('Sign in', 'Sign Up');

  public static readonly FORGOT_PASSWORD = new Page('Forgot password', 'Sign Up');

  public static readonly CONFIRMATION_CODE = new Page('Confirmation Code', 'Sign Up');

  public static readonly PROGRAMS_CALENDAR = new Page('Programs Calendar');

  public static readonly PROGRAMS_TABLE = new Page('Programs Table');

  public static readonly PROGRAM_DEEP_LINK = new Page('Program Deep Link');

  public static readonly PROGRAM_CREATE = new Page('New Program');

  public static readonly PROGRAM_UPDATE = new Page('Program Details');

  public static readonly PROGRAM_COPY = new Page('Copy Program');

  public static readonly TASK_TO_PROGRAM = new Page('Task To Program');

  public static readonly ATTACHMENT_VIEW = new Page('Attachment View');

  public static readonly ANALYTICS = new Page('Analytics');

  public static readonly ANALYTICS_ENTERPRISE = new Page('Analytics for enterprise');

  public static readonly INTEGRATIONS = new Page('Integrations');

  public static readonly INTEGRATION_UPDATE = new Page('Integration Details');

  public static readonly USERS_MANAGEMENT = new Page('Users Management');

  public static readonly USER_CREATE = new Page('New User');

  public static readonly USER_UPDATE = new Page('User Details');

  public static readonly USER_DELETE = new Page('Delete User');

  public static readonly USER_PROFILE = new Page('User Profile');

  public static readonly PROGRAM_TYPES = new Page('Program Types');

  public static readonly PROGRAM_TYPE_CREATE = new Page('New Program Type');

  public static readonly PROGRAM_TYPE_UPDATE = new Page('Program Type Details');

  public static readonly PROGRAM_TYPE_DELETE = new Page('Delete Program Type');

  public static readonly RECOMMENDATIONS = new Page('Recommendations');

  public static readonly BILLING = new Page('Billing');

  public static readonly NOTIFICATION_SETTINGS = new Page('Notification Settings');

  public static readonly PERSONAL_INTEGRATIONS = new Page('Personal Integrations');

  public static readonly GROWEGY_AI = new Page('Growegy AI');

  public static readonly ADD_EIN = new Page('Add EIN');

  public static readonly ENABLE_SMS_NOTIFICATIONS = new Page('Enable SMS Notifications');

  public static readonly CANCELLATION_WIZARD_BENEFITS = new Page('Cancellation Wizard: Benefits');

  public static readonly CANCELLATION_WIZARD_INITIAL = new Page('Cancellation Wizard: Initial');

  public static readonly CANCELLATION_WIZARD_FEEDBACK = new Page('Cancellation Wizard: Feedback');

  public static readonly CANCELLATION_WIZARD_FINAL = new Page('Cancellation Wizard: Final');

  public static readonly MARKETPLACE = new Page('Marketplace');

  public static readonly BUSINESS_PLAN_INTRO = new Page('Business Plan: Intro');

  public static readonly BUSINESS_PLAN_VARIABLES = new Page('Business Plan: Variables');

  public static readonly BUSINESS_PLAN_SECTION = new Page('Business Plan: Section');

  public static readonly BUSINESS_PLAN_REVIEW_AND_DOWNLOAD = new Page(
    'Business Plan: Review and Download'
  );

  public static readonly BUSINESS_PLAN_FINANCIAL_ANALYSIS = new Page(
    'Business Plan: Financial Analysis'
  );

  public static readonly RELEASE_PROMPT = new Page('Release Prompt');

  public static readonly ONBOARDING_WIZARD_STEP = new Page('Onboarding Wizard Step');

  public static readonly REACTIVATION_BANNER = new Page('Reactivation Banner');

  public static readonly FUNDING = new Page('Funding');

  private readonly pageName;

  private readonly pageCategory;

  constructor(name: string, category: string | undefined = undefined) {
    this.pageName = name;
    this.pageCategory = category;
  }

  get name(): string {
    return this.pageName;
  }

  get category(): string | undefined {
    return this.pageCategory;
  }
}
